import React from "react";
import { AlertDialog } from "../../components/AlertDialog";
import { ToastAlert } from "../../components/ToastAlert";
import TalentoAutentico from "../../components/TalentoAutentico/TalentoAutentico";
import { CustomAlert } from "../../components/CustomAlert/CustomAlert";
import { GradesActions } from "../../components/grades/GradesActions";
import { SponteArea, SponteButtons } from "./styles";
import { normalizeStudentsByClassroom } from "../../utils/sponteDataNormalizer";

/**
 * Seção responsável pelas ações de integração com o Sponte
 * (atualizar visibilidade, calcular/enviar notas finais, Talento Autêntico).
 *
 * Componente puramente de apresentação; toda a lógica de negócio
 * (estado, chamadas de API, etc.) permanece no container `Grades`.
 */
export const SponteSection = ({
  user,
  classrooms,
  period,
  subject,
  studentsByClass,
  loading,
  show,
  setShow,
  type,
  message,
  showMessage,
  setShowMessage,
  infoMessage,
  talentoAutenticoOpen,
  setTalentoAutenticoOpen,
  open,
  setOpen,
  sendFinalGrades,
  updateAllVisibility,
  onValidateAverages,
  validatingGrades = false,
  failedFinalSendCount = 0,
  onRetryFailedFinalGrades,
  retryFailuresCooldownSecondsLeft = 0,
}) => {
  // Normalizar studentsByClass para garantir que seja sempre um array
  const normalizedStudents = normalizeStudentsByClassroom(studentsByClass);

  const canShowSection =
    ["admin", "coordinator"].includes(user.level) &&
    classrooms.length > 0 &&
    period !== undefined &&
    subject !== undefined;

  if (!canShowSection) {
    return null;
  }

  return (
    <SponteArea>
      <ToastAlert show={show} setShow={setShow} type={type} message={message} loading={loading} />

      <SponteButtons>
        <GradesActions
          loading={loading || validatingGrades}
          disabled={normalizedStudents.length === 0 || validatingGrades}
          onUpdateVisibility={undefined} // Não é mais necessário - checkbox salva automaticamente
          onOpenFinalGradesModal={() => setOpen(true)}
          onValidateAverages={onValidateAverages}
          failedFinalSendCount={failedFinalSendCount}
          onRetryFailedFinalGrades={onRetryFailedFinalGrades}
          retryFailuresCooldownSecondsLeft={retryFailuresCooldownSecondsLeft}
          onOpenTalentoAutentico={() => {
            if (normalizedStudents.length > 0) {
              setTalentoAutenticoOpen(true);
            } else {
              // Mantém o mesmo comportamento de aviso ao usuário
              setShow(true);
            }
          }}
        />
      </SponteButtons>

      <AlertDialog
        open={open}
        setOpen={setOpen}
        title="Confirmação de alteração entre sistemas!"
        body={"Você confirma o envio de todos os dados de notas ao Sponte?"}
        handleConfirm={async () => {
          try {
            await sendFinalGrades();
          } catch (error) {
            // O container ainda é responsável por configurar mensagem/tipo
            console.error("Erro ao enviar notas ao Sponte:", error);
            setShow(true);
          }
        }}
      />

      <TalentoAutentico
        open={talentoAutenticoOpen}
        onClose={() => setTalentoAutenticoOpen(false)}
        studentsByClass={studentsByClass}
        classrooms={classrooms}
        period={period}
        user={user}
      />

      <CustomAlert
        infoType="success"
        status={showMessage}
        setStatus={setShowMessage}
        infoMessage={infoMessage}
      />
    </SponteArea>
  );
};








